import { render, staticRenderFns } from "./2_donationAmount.vue?vue&type=template&id=34ced2e1"
import script from "./2_donationAmount.vue?vue&type=script&lang=js"
export * from "./2_donationAmount.vue?vue&type=script&lang=js"
import style0 from "./2_donationAmount.vue?vue&type=style&index=0&id=34ced2e1&prod&lang=scss"
import style1 from "./2_donationAmount.vue?vue&type=style&index=1&id=34ced2e1&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports